import { useState, memo, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import { compose } from 'recompose';
import { isNotAssignedPickup } from '../../../../filterUtils';
import { withAppConfig } from '../../../../../../../../appConfigContext';
import { PICKUP_MANAGEMENT_MODES } from '../../../PickupManagement/constants';
import StyledToolTip from '../../../../../../../common/StyledToolTip';

const NoFreightPickup = ({
  classes,
  headerId,
  eventHub,
  terminalOffset,
  configJSON,
}) => {
  const [enable, setEnable] = useState(false);
  useEffect(() => {
    eventHub.on(`${headerId}_updatePickupManagementIconStatus`, changeNoFreightPickupStatus);
    return () => {
      eventHub.off(`${headerId}_updatePickupManagementIconStatus`, changeNoFreightPickupStatus);
    };
  }, [enable, terminalOffset]);

  const changeNoFreightPickupStatus = ({ selectedPickups }) => {
    if (!configJSON.enableNoFreightForUnassignedPickup) {
      return;
    }
    const isEnabled =
      selectedPickups.length === 1 &&
      isNotAssignedPickup({ pickup: selectedPickups[0], terminalOffset });
    if (enable !== isEnabled) {
      setEnable(isEnabled);
    }
  };

  const getTooltipMessage = () => {
    if (!configJSON.enableNoFreightForUnassignedPickup) {
      return 'No Freight Pickup (Disabled)';
    } else if (enable) {
      return "Mark as 'No Freight'";
    }
    return "Select one unassigned pickup to mark as 'No Freight'";
  };

  const handleClick = () => {
    if (enable) {
      eventHub.emit('pickupManagement', {
        action: PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP
      });
    }
  };

  return (
    <div
      className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons ${
        enable ? classes.enabledIcon : classes.disableIcon
      }`}
      onClick={handleClick}>
      <StyledToolTip title={getTooltipMessage()}>
        <div className={classes.noFreightIcon}>NF</div>
      </StyledToolTip>
    </div>
  );
};

export default compose(withStyles(styles), withAppConfig)(memo(NoFreightPickup));
